import angular from 'angular';

import { CodeTypeModel }           from '../core/models/code-type';
import { JsonService } from '../core/services/json.service';
import { InspectionTemplateModel } from './models/inspection.template';
import { InspectionTemplateItemModel } from './models/inspection.template.item';

interface InspectionTemplateScope extends ng.IScope {
  addGroup      : () => void;
  addItem       : ( group : any ) => void;
  copy          : () => void;
  delete        : () => void;
  form          : ng.IFormController;
  group         : CodeTypeModel;
  originalGroups: Array<CodeTypeModel>;
  removeGroup   : ( index : number ) => void;
  removeItem    : ( group : any, item : InspectionTemplateItemModel ) => void;
  save          : ( form: ng.IFormController ) => void;
  template      : any;
};


export function InspectionTemplateCtrl (
  $scope             : ng.IScope,
  $state             : ng.ui.IStateService,
  $translate         : ng.translate.ITranslateService,
  confirm            : any,
  groups             : Array<CodeTypeModel>,
  InspectionTemplate : any,
  jsonApi            : JsonService,
  messages           : any,
  modalApi           : any,
  template           : InspectionTemplateModel,
  types              : Array<CodeTypeModel>,
  workshopAPI        : any
) {
  var vm : InspectionTemplateScope = this;

  vm.originalGroups = jsonApi.copy(groups);
  vm.template       = new InspectionTemplate(template, groups, types);

  vm.addGroup = function () {
    vm.template.addGroup(vm.group);

    vm.group = undefined;

    vm.form.$setDirty();
  };

  vm.addItem = function ( group : any ) {
    group.addItem();

    vm.form.$setDirty();
  };

  vm.copy = function () {
    modalApi.capture({
      capture: 'Name of Template',
      title  : 'Copy Inspection Template'
    })
    .then(name => vm.template.copy(name))
    .then(result => {
      vm.template = new InspectionTemplate(result, groups, types);

      messages.show('Inspection Template Copied.', 'success');
    })
    .catch(( err : any ) => messages.error(err));
  };

  vm.removeGroup = function ( index : number ) {
    vm.template.removeGroup(index);

    vm.form.$setDirty();
  };

  vm.removeItem = function ( group : any, item : InspectionTemplateItemModel ) {
    group.removeItem(item);

    vm.form.$setDirty();
  };

  vm.save = function () {
    vm.template.save()
    .then(( template : InspectionTemplateModel ) => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.TEMPLATE'), 'success');

      $state.go('app.inspection-template', {
        id: template.id
      }, {
        reload: true
      });
    })
    .catch(( err : any ) => {
      messages.error(err);

      $state.reload();
    });
  };

  vm.delete = function () {
    confirm.generic($translate.instant('JS_SPACE.CONFIRM.DELETE_TEMPLATE'))
    .then(() => workshopAPI.delete('/inspection_template', vm.template.id))
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.DELETED.TEMPLATE'), 'success');

      $state.go('app.inspection-templates')
    })
    .catch(( err : any ) => {
      messages.error(err);
    });
  };

  $scope.$watch(() => vm.template.groups.length, () => {
    var originalGroups = jsonApi.copy(vm.originalGroups);
    var groupCodes = [];

    angular.forEach(vm.template.groups, ( group : CodeTypeModel ) => {
      groupCodes.push(group.code);
    });

    vm.template.groupOptions = originalGroups.filter(( group : CodeTypeModel ) => groupCodes.indexOf(group.code) < 0);
  });

};